import React from "react";
import Select from "react-select";

const CustomSelect = (props) => (
  <div className={props.wrapperClass || "fin-col"}>
    <label>{props.label}</label>
    <Select
      {...props}
      className="react-select-container"
      classNamePrefix="react-select"
      value={props.input.value}
      onChange={(value) => props.input.onChange(value)}
      onBlur={() => props.input.onBlur(props.input.value)}
      options={props.options}
    />
    {(props.meta.error || props.meta.submitError) && props.meta.touched && (
      <p className="text-center text-error">
        {props.meta.error || props.meta.submitError}
      </p>
    )}
  </div>
);
export default CustomSelect;
